import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from 'src/app/core/apiConfig';
import { CustomerServiceData } from 'src/app/core/data/admin/customers-data';
import { BaseResponse, CustomerDTO } from 'src/app/core/models';
import { UtilityService } from '../../shared-services/utility.service';

@Injectable({
  providedIn: 'root'
})
export class CustomersService extends CustomerServiceData {
  getAdminDashboardInfo(): Observable<BaseResponse<any>> {
    return this.utilityService.get<any>(
    ApiConfig.selfcare.getAdminDashboardInfo,
      null,
      null,
      "get"
     )
  }
  constructor(private utilityService: UtilityService) {
    super();
  }
  
  getAllCustomers(id?: any, isActive?: any, isDeleted?: any): Observable<BaseResponse<CustomerDTO[]>> {
    return this.utilityService.postPut<CustomerDTO[]>(
      ApiConfig.admin.getcustomers,
      null,
      null,
      "post",
      { id: id ?? 0,
        isActive: isActive == null ? '' : isActive ,
        isDeleted: isDeleted == null ? '' : isDeleted ,

      })
  }

  getAllsCustomers(): Observable<BaseResponse<CustomerDTO[]>> {
    return this.utilityService.postPut<any>(
      ApiConfig.admin.getAllcustomers,
      null,
      null,
      "post",
      { 

      })
  }
}
